module.exports = __webpack_public_path__ + "static/media/red-dot.7f8e55af.svg";